<template>
  <div v-if="html" class="relative flex items-center">
    <span class="icon red-info ms-1.5 size-4" @mouseenter="visible = true" @mouseleave="visible = false"></span>
    <div ref="elem" :class="classes" v-html="html"></div>
  </div>
</template>
<script>
export default {
  props: {
    html: {
      type: String,
    },
    class: {
      type: String,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    classes() {
      let classes = ["tooltip", "rich-text", "vsmall-p"];
      if (this.visible) {
        classes.push("show");
      }
      return (this.class ? this.class : "") + " " + classes.join(" ");
    },
  },
};
</script>
